import { Provider } from "react-redux";
import { store } from "./store/storeConfiguration";
import Routing from "./Routing";
import "bootstrap/dist/css/bootstrap.min.css";
import "font-awesome/css/font-awesome.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "./custom-style.css";
import "./fonts/stylesheet.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useState } from "react";
import Footer from "./components/footer";
import { onMessageListener } from "./firebase";
import ReactNotificationComponent from "./components/notifications/reactNotification";
import {
 addNotification,
 getAllNotifications,
} from "./store/Notification/action";

function App() {
 const [show, setShow] = useState(false);
 const [notification, setNotification] = useState({ title: "", body: "" });

 onMessageListener()
  .then((payload) => {
   setShow(true);
   setNotification({
    title: payload?.notification?.title,
    body: payload?.notification?.body,
   });
   store.dispatch(
    addNotification({ type: payload?.notification?.title, ...payload?.data })
   );
   setTimeout(() => {
    store.dispatch(getAllNotifications());
   }, 2000);
  })
  .catch((err) => console.log("onMessageListenerError: ", err));

 //This effectively disables any console output from these methods when the environment is not set to "qa"
 if (process.env.REACT_APP_ENV !== "qa") {
  console.log = () => {};
//   console.debug = () => {};
  console.info = () => {};
  console.warn = () => {};
 }
 return (
  <Provider store={store}>
   {show ? (
    <ReactNotificationComponent
     title={notification?.title}
     body={notification?.body}
    />
   ) : (
    <></>
   )}
   <ToastContainer />
   <Routing />
   <Footer />
  </Provider>
 );
}

export default App;
